<template>
  <div id="about" class="page modal">
    <div class="inner">
      <h2>ABOUT</h2>
      <section>
        <h3>COMPANY NAME<span>会社名</span></h3>
        <p>株式会社未来演算研究所</p>
      </section>
      <section>
        <h3>BUSINESS<span>事業内容</span></h3>
        <p>情報の収集、分析、管理及び情報処理サービス業、<br>情報提供サービス業並びに情報処理に関する研究及び開発</p>
      </section>
      <section>
        <h3>ESTABLISH<span>設立年月日</span></h3>
        <p>2018年9月3日</p>
      </section>
      <section>
        <h3>THE BOARD<span>役員</span></h3>
        <p>代表取締役 永谷栄宏</p>
      </section>
      <section>
        <h3>CORPORATE WEB SITE<span>コーポレートサイト</span></h3>
        <p>https://fci.jp/</p>
      </section>
      <section>
        <h3>HISTORY</h3>
        <ul>
          <li><span class="date">2018-09-03</span><span class="text">株式会社未来演算研究所を設立</span></li>
        </ul>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'About'
}
</script>

<style scoped lang="scss">
#about {
  height: 100vh;
  width: 100vw;
  background: linear-gradient(to left, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 25%, rgba(255,255,255,1) 75%, rgba(255,255,255,0) 100%);
  color: #232323;
  padding: 15vh 20vw;
  text-align: center;
  overflow: hidden;

  .inner {
    overflow: auto;
    width: 100%;
    height: 100%;
  }

  h2, h3 {
    font-family: 'Roboto', sans-serif;
    font-weight: 100;
  }

  h2 {
    color: #232323;
  }

  section {
    padding: 2rem 0;

    h3 {
      color: #232323;
      font-size: 1.25rem;
      position: relative;
      padding: .5rem 0;

      &:after {
        content: "";
        position: absolute;
        left: calc(50% - 75px);
        bottom: 0;
        width: 150px;
        height: 4px;
        background: repeating-linear-gradient(-45deg, #ED1C24, #ED1C24 2px, transparent 2px, transparent 4px);
      }

      span {
        display: block;
        font-size: 0.75rem;
        padding-top: 0.25rem;
      }
    }

    p {
      padding: 1rem;
      letter-spacing: 0.1rem;
      width: 600px;
      max-width: 100%;
      margin: 0 auto;
    }

    ul {
      list-style: none;
      padding-top: 1rem;

      li {
        font-size: 0.75rem;

        span {
          display: inline-block;
        }

        .date {
          width: 100px;
        }
      }
    }

  }
}
</style>



// WEBPACK FOOTER //
// src/components/About.vue